<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col
                  v-for="(item, index) in dataList"
                  :key="index"
                  :span="12"
                >
                  <el-form-item :label="item.name">
                    <el-input
                      v-if="item.type === 'textarea'"
                      v-model="item.data"
                      type="textarea"
                      autosize
                      disabled
                    />
                    <span v-else-if="item.type === 'image'">
                      <img
                        :src="baseUrl + item.data"
                        style="width: 150px;height: 150px;cursor: pointer;"
                        @click="previewImage(item.data)"
                      >
                    </span>
                    <span v-else-if="item.type === 'video'">
                      <i
                        class="el-icon-video-play"
                        style="color: #67C23A; font-size: 68px;"
                        @click="handlePlayVideo(item.data)"
                      />
                    </span>
                    <el-input
                      v-else
                      v-model="item.data"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="上传数据时间">
                    <el-input
                      v-model="dialogAddEditViewForm.commitTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              审核信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="审核人">
                    <el-input
                      v-model="dialogAddEditViewForm.auditorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核时间">
                    <el-input
                      v-model="dialogAddEditViewForm.auditTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核结果">
                    <el-input
                      v-model="dialogAddEditViewForm.statusValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="获取成长值">
                    <el-input
                      v-model="dialogAddEditViewForm.integral"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="评价内容">
                    <el-input
                      v-model="dialogAddEditViewForm.evaluate"
                      type="textarea"
                      autosize
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="dialogImageVisible"
      :before-close="imageModalClose"
      class="preview-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div
        v-if="dialogImageVisible"
        class="block"
      >
        <span
          class="el-image-viewer__btn el-image-viewer__close"
          @click="imageModalClose"
        ><i class="el-icon-error" /></span>
        <el-carousel
          trigger="click"
          height="600px"
          class="imgbox"
          :autoplay="false"
          arrow="always"
          indicator-position="outside"
        >
          <el-carousel-item
            v-for="(item, index) in imagesArray"
            :key="index"
          >
            <img
              :src="item"
              style="max-height: 100%; max-width: 100%;"
            >
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>

    <!-- 视频播放 -->
    <el-dialog
      v-if="dialogVideoVisible"
      title="播放视频"
      :visible.sync="dialogVideoVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      append-to-body
    >
      <div>
        <video
          :src="videoUrl"
          controls="controls"
          class="avatar video-avatar"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="videoModalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { initInfoDataApi, initApi } from '@/api/appActivityDataAcquisition'
export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {},
      dataList: [],
      baseUrl: process.env.VUE_APP_BASE_API,
      dialogImageVisible: false,
      imagesArray: [],
      dialogVideoVisible: false,
      videoUrl: ""
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          commitTimeValue: '',
          evaluate: '',
          integral: '',
          auditorName: '',
          auditTimeValue: '',
          statusValue: ''
        }
        this.dataList = []
        this.imagesArray = []
        this.initPageData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData() {
      initInfoDataApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }

        this.dialogAddEditViewForm.id = data.id
        this.initActivityData(data.activityDataId, JSON.parse(data.formData))
        this.loading = false
      })
    },
    initActivityData(id, formData) {
      initApi({ id: id }).then(res => {
        const { data } = res
        let formItem = JSON.parse(data.formItem)
        formItem.forEach(item => {
          let obj = {}
          obj.name = item.itemName
          obj.type = item.itemType
          formData.forEach(dataItem => {
            if (dataItem.itemField === item.itemField) {
              obj.data = dataItem.itemValue
            }
          })
          this.dataList.push(obj)
        })
      })
    },
    // 预览图片
    previewImage(url) {
      let _this = this;
      _this.imagesArray = [_this.baseUrl + url];
      _this.dialogImageVisible = true;
    },

    // 关闭预览图片
    imageModalClose() {
      this.dialogImageVisible = false;
    },
    // 播放视频
    handlePlayVideo(url) {
      let _this = this;
      _this.videoUrl = _this.baseUrl + url;
      _this.dialogVideoVisible = !_this.dialogVideoVisible;
    },
    // 关闭视频播放弹窗
    videoModalClose() {
      this.dialogVideoVisible = false;
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.preview-dialog {
  width: 100%;
  height: 100%;
  overflow: hidden;
  ::v-deep .el-dialog {
    height: 100%;
    width: 100%;
    margin-top: 0vh !important;
    overflow: hidden;
    background: transparent;
  }
  ::v-deep .el-dialog .el-dialog__body {
    // margin-top: -60px;
    border-top: none;
    border-bottom: none;
  }
}
.el-carousel__item {
  text-align: center;
}
::v-deep .el-image-viewer__btn {
  position: fixed;
  right: 20px;
  top: 10px;
  z-index: 999;
}
.el-image-viewer__close {
  color: #fff;
  .el-icon-error:before {
    color: #fff;
  }
}
</style>
